import { __module as r } from "./ghl-ui.es1737.js";
import { i as j } from "./ghl-ui.es1541.js";
import { b as M } from "./ghl-ui.es1738.js";
import { b as W } from "./ghl-ui.es1739.js";
(function(n, t) {
  var i = j.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = i(M), d = i(W), s = /^(\d+)(th|st|nd|rd)?/i, o = /\d+/i, u = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, m = {
    any: [/^b/i, /^(a|c)/i]
  }, h = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, f = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, l = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, c = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, p = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, v = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, P = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, b = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, y = {
    ordinalNumber: (0, d.default)({
      matchPattern: s,
      parsePattern: o,
      valueCallback: function(e) {
        return parseInt(e, 10);
      }
    }),
    era: (0, a.default)({
      matchPatterns: u,
      defaultMatchWidth: "wide",
      parsePatterns: m,
      defaultParseWidth: "any"
    }),
    quarter: (0, a.default)({
      matchPatterns: h,
      defaultMatchWidth: "wide",
      parsePatterns: f,
      defaultParseWidth: "any",
      valueCallback: function(e) {
        return e + 1;
      }
    }),
    month: (0, a.default)({
      matchPatterns: l,
      defaultMatchWidth: "wide",
      parsePatterns: c,
      defaultParseWidth: "any"
    }),
    day: (0, a.default)({
      matchPatterns: p,
      defaultMatchWidth: "wide",
      parsePatterns: v,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, a.default)({
      matchPatterns: P,
      defaultMatchWidth: "any",
      parsePatterns: b,
      defaultParseWidth: "any"
    })
  }, w = y;
  t.default = w, n.exports = t.default;
})(r, r.exports);
var q = r.exports;
export {
  q as m
};
